import styled from '@emotion/styled';
import React from 'react';
import data from '../../utils/dbSchema';
import Layout from '../Layout';
import { Box } from '../UI';
import PortfolioTable from './Table';
import Charts from './Charts';
import Meta from './Meta';
import PageTitle from '../Layout/PageTitle'

export default function MyPortfolio({ match }) {
	const { path } = match;
	const [currency, setCurrency] = React.useState('EUR');
	const handleChange = event => {
		setCurrency(event.target.value);
	};
	return (
		<Layout path={path}>
			<Box p="30px">
				<PageTitle title='AZ Asset Management' subtitle='Portfolio 1 (AZAM Sarl)'>
					<Meta currency={currency} handleChange={handleChange}/>
				</PageTitle>
				<PortfolioTable data={data} currency={currency} />
				{/* <Charts /> */}
			</Box>
		</Layout>
	);
}

const Title = styled.div`
	padding: 0.5rem 1rem;
	background: #eee;
	border-radius: 30px;
	display: inline-block;
`;
